"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../helpers/customPropTypes");

require("./Spinner.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var spinnerSize = {
  large: "aclui-spinner--large",
  medium: "aclui-spinner--medium",
  small: "aclui-spinner--small",

  // deprecated values
  default: "aclui-spinner--medium",
  tiny: "aclui-spinner--small"
};

var Spinner = function Spinner(_ref) {
  var ariaText = _ref.ariaText,
      className = _ref.className,
      caption = _ref.caption,
      size = _ref.size,
      moreProps = _objectWithoutProperties(_ref, ["ariaText", "className", "caption", "size"]);

  var rootClasses = (0, _classnames2.default)("aclui-spinner", className, spinnerSize[size]);

  var bestAria = function bestAria() {
    return ariaText || caption || "Loading";
  }; // TODO: l10n

  return _react2.default.createElement(
    "div",
    _extends({ className: rootClasses, "data-qa-anchor": "aclui-spinner" }, moreProps),
    _react2.default.createElement("div", { className: "aclui-spinner__visual" }),
    _react2.default.createElement(
      "div",
      { className: "aclui-spinner__caption" },
      caption
    ),
    _react2.default.createElement(
      "div",
      { className: "aclui-spinner__aria-alert", role: "alert", "aria-live": "polite" },
      bestAria()
    )
  );
};

Spinner.propTypes = {
  ariaText: _propTypes2.default.string,
  className: _propTypes2.default.string,
  caption: _propTypes2.default.string,

  /** customPropTypes shirtSize */
  size: _customPropTypes.shirtSize
};

Spinner.defaultProps = {
  ariaText: null,
  className: null,
  caption: null,
  size: "medium"
};

exports.default = Spinner;